module.exports = __webpack_public_path__ + "static/media/WM7@1.5x.9290ae3f.png";